import React,{useEffect, useState,useRef} from 'react'
import { useNavigate,useLocation } from 'react-router-dom'
import {IoChevronBackOutline} from "react-icons/io5"
import {user} from "../database/ExportAssets"
import {Sidemenu} from '../components'
import menu from "../assets/icons/menu.svg"
import { HeadersText as text } from '../database/Text'
import { useMainContext } from '../callContext/MainContext'
const Header = () => {
  const location=useLocation();
  const {language}=useMainContext();
  const navigate=useNavigate();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [title,setTitle]=useState("");
  const [showHeader,setShowHeader]=useState(false);
  const [isLanding,setIsLanding]=useState(false);
  const handleToggleMenu = () => {
    console.log("Image clicked")
    setMenuOpen((prev) => !prev);
  };
  const handleClick=()=>
  {
    navigate("/account")
  }
  useEffect(()=>
  {
    if(location?.pathname == "/home")
    {
      setShowHeader(true)
    }
    else
    {
      setShowHeader(false)
      if(location?.pathname == "/account")
      {
        setTitle(text?.accountText?.[language])
      }
      else if(location?.pathname == "/calls")
      {
        setTitle(text?.contactText?.[language])
      }
      else if(location?.pathname == "/language")
        {
          setTitle(text?.langText?.[language])
        }
      else if(location?.pathname == "/landing")
      {
        setShowHeader(false)
        setIsLanding(true)
        return ;
      }
      else 
      {
        setTitle("Error Page")
      }

    }
  },[location])
  if(isLanding)
  {
    // setShowHeader(false)
    return ;
  }
  return (
    <>
    {showHeader ?<div className="fixed top-0 bg-header p-4 flex  cursor-pointer z-[500] text-white font-normal shadow-md shadow-gray-600 h-shadow text-xl w-full">
          <div onClick={()=>setMenuOpen(true)}><img  src={menu} alt="user" className='h-9' /></div>
         <div className='font-bold mr-44 m-auto'>{text.magicVoiceText[language]}</div>
    </div>:
    
    <div className="fixed top-0 bg-header p-4 flex  cursor-pointer text-white font-normal z-[500] shadow-md shadow-gray-600  h-shadow text-xl w-full">
    <div className=' font-bold' onClick={()=>navigate(-1)} ><IoChevronBackOutline size={30}/></div>
    <div className='m-auto text-center font-bold'>{title}</div>
   </div>

  }
<Sidemenu isOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
  </>
  )
}

export default Header